import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { DeptUserBaseStoreContext } from '../contexts/StoreContext'
import { DeptUserBaseStore } from '../store/interface'

export const useDeptUserBaseStore = <M extends boolean, StateSlice>(
  selector: (store: DeptUserBaseStore<M>) => StateSlice
) => {
  return useContextStore<DeptUserBaseStore<M>, StateSlice>(
    DeptUserBaseStoreContext as any,
    selector
  )
}

export const useDeptUserBaseStoreApi = <M>() => {
  return useContextStoreApi<DeptUserBaseStore<M>>(
    DeptUserBaseStoreContext as any
  )
}
